import { createSelector, createFeatureSelector } from "@ngrx/store";
import { CartState } from "./cart.state";

export const cartStateSelector = createFeatureSelector<CartState>("cart");

export const cartSelector = createSelector(cartStateSelector, (state) => state);
export const cartProductSelector = createSelector(cartStateSelector, (state) => state?.products);
export const cartCurrentProductSelector = createSelector(cartStateSelector, (state) => state?.products?.currentProduct);
export const cartMobileProductSelector = createSelector(cartStateSelector, (state) => state?.products?.mobile);
export const cartCostsSelector = createSelector(cartStateSelector, ({ dueToday, monthlyCost }) => {
	return {
		dueToday,
		monthlyCost
	};
});
